import { render } from "./ProductosView.vue?vue&type=template&id=23821457"
import script from "./ProductosView.vue?vue&type=script&lang=js"
export * from "./ProductosView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__